import { getUserInfo, settingDetail } from '../../http/api'
const state = {
  userInfo: localStorage.userInfo || {},
  token: localStorage.token || '',
  settingDetail: {},
  enterpriseGlobalObj: {
    enterpriseId: '',
    enterpriseName: '',
  },
}
const getters = {}
const mutations = {
  changeKey(state, payload) {
    for (let i in payload) {
      state[i] = null
      state[i] = payload[i]
    }
  },
}
const actions = {
  getUserInfoFunc({ commit }, params) {
    return new Promise((resolve, reject) => {
      getUserInfo(params)
        .then((data) => {
          commit('changeKey', {
            userInfo: data,
          })
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getSettingDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      settingDetail(params)
        .then((data) => {
          commit('changeKey', {
            settingDetail: data,
          })
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}
export default { state, getters, mutations, actions }
